import { ActivityReason, } from '@office-start/document-types';
import { useMemo } from 'react';
export function usePerson(item, currentTab, msaUserHint, youLabelString) {
    var _a;
    //TODO: add 'you' capability
    return useMemo(function () {
        var _a, _b;
        if (currentTab === 'shared') {
            if (item.isShared) {
                if (item.sharedByUsername) {
                    return {
                        upn: item.sharedByEmail,
                        tag: 'c0',
                        name: item.sharedByUsername,
                    };
                }
                return null;
            }
            else {
                if (msaUserHint &&
                    ((_a = item.activity) === null || _a === void 0 ? void 0 : _a.reasonType) === ActivityReason.Share &&
                    item.sharedByUsername) {
                    return {
                        upn: '',
                        name: item.sharedByUsername,
                    };
                }
                return null;
            }
        }
        else {
            if (msaUserHint &&
                ((_b = item.driveId) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === msaUserHint.toLowerCase()) {
                return {
                    upn: '',
                    name: youLabelString || 'You',
                };
            }
            return {
                upn: item.creatorUpn,
                tag: 'c0',
                name: item.creatorName,
            };
        }
    }, [
        currentTab,
        item.isShared,
        (_a = item.activity) === null || _a === void 0 ? void 0 : _a.reasonType,
        item.sharedByUsername,
        item.sharedByEmail,
        item.driveId,
        item.creatorUpn,
        item.creatorName,
        msaUserHint,
        youLabelString,
    ]);
}
//# sourceMappingURL=usePerson.js.map